const isHtmlMenuScrapedInDebugMode = menu => menu.isHtmlMenuScrapedInDebugMode

export default isHtmlMenuScrapedInDebugMode
